import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-100 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-500/60 transition-colors animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 0.05}s` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-300">
        <img
          src={movie.poster}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - 十八禁影视大全`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2.5 left-2.5 bg-background-50/85 backdrop-blur-sm text-foreground-900 text-[11px] px-2 py-1 rounded-md font-label">
          {movie.type === 'movie' ? '电影' : '剧集'}
        </span>
        <span className="absolute top-2.5 right-2.5 bg-accent-500 text-background-50 text-[11px] font-bold px-2 py-1 rounded-md">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="absolute bottom-3 left-3 right-3 text-xs text-foreground-950 opacity-0 group-hover:opacity-100 transition-opacity line-clamp-2">
          {movie.synopsis}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm text-foreground-900 font-medium truncate group-hover:text-primary-400 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-2 text-xs text-foreground-500 flex flex-wrap items-center gap-x-2 gap-y-1">
          <span>{movie.year}</span>
          <span className="text-background-400">·</span>
          <span>{movie.region}</span>
          <span className="text-background-400">·</span>
          <span className="truncate">{movie.genres.join('/')}</span>
        </p>
      </div>
    </Link>
  );
}